import { React, useEffect, useState } from "react";
import logo from "../../assets/img/logo-white.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import { Badge } from "primereact/badge";
import { useDispatch, useSelector } from "react-redux";
import { getNewDocuments } from "../../api/api";
import { useQuery } from "@tanstack/react-query";
import {
  toggleMenuDisplay,
  collapseMenuDisplay,
  setLatestDocument,
} from "../../store/reducer";
import { getNotificationRoute } from "../utilities";
import { notificationMenu, cartMenu } from "../constant";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Header component containing the main menu and cart/notification badges.
 * @function
 * @returns {JSX.Element} The JSX element representing the header component.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com> 2024/05/12
 */


export default function Header() {
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);
  const userID = useSelector((state) => state.user.userID);
  const unread_nb = useSelector((state) => state.appState.unread_nb);
  const cartCounter = useSelector((state) => state.cart.counter);
  const latestDocs = useSelector((state) => state.appState.latestDocuments);

  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const { data, isLoading, error } = useQuery({
    queryKey: ["newFiles", userID],
    queryFn: () => getNewDocuments(userID),
    enabled: !!userID,
    // refetchInterval: 1000 * 60 * 60 * 2,
  });

  useEffect(() => {
   
    if (data) {
      dispatch(setLatestDocument(data));
    }
  }, [data, dispatch]);

  const languages = [
    {
      id: 1,
      code: "en",
      name: "English",
    },
    {
      id: 1,
      code: "fr",
      name: "Francais",
    },
  ];

  const handleMenuDisplay = (e, item) => {
    e.preventDefault();


    if (item.id === "notification") {
      let children = getNotificationRoute(latestDocs);
     
      if (children) {
        item.children = children;
      }
    }
    if (item.children.length > 0) {
      item.firstChildID = item.children[0].id;
      let firstChildUrl = item.children[0].url;

      dispatch(toggleMenuDisplay(item));
      navigate(firstChildUrl);
    }else if(item.id === "notification"){
      dispatch(toggleMenuDisplay([]));
      navigate('/notification');
    }
  };

  const goHome = (e) => {
    e.preventDefault();
    const item = {
      name: "home",
      id: "home",
      type: "post",
      icon: "",
      url: "/",
    };
    dispatch(toggleMenuDisplay(item));
    if (item?.url) {
      navigate(item.url);
    }
  };

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
  };

  // if (isLoading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error.message}</div>;
  // if (!data) return <div>No data available</div>;

  return (
    <div>
      <Navbar expand="lg" className="col-12 header" sticky="top">
        <Container fluid className="">
          <Navbar.Brand href="/" onClick={(e) => goHome(e)}>
            <img src={logo} alt="logo" className="logo-white" />
          </Navbar.Brand>

          <Navbar.Text className="">
            <h3 className="text-white app-title-main">
              BEACHCOMBER <span className="bcb-primary-color"> B2B</span>
            </h3>
          </Navbar.Text>

          <Nav className="justify-content-end">
            {/* <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="lang-dropdown"
                className="text-white text-smallest text-uppercase "
              >
                {i18n.language}
              </Dropdown.Toggle>

              <Dropdown.Menu className="lang-dropdown-menu">
                {languages.map((lang, index) => {
                  return (
                    <Dropdown.Item
                      key={"lang-" + lang.code}
                      href=""
                      className="text-capitalize"
                      onClick={() => changeLanguage(lang.code)}
                    >
                      {lang.code}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown> */}
          </Nav>
        </Container>
      </Navbar>

      <Navbar expand="lg" className=" bg-body-tertiary sub-header">
        <Container fluid className="">
          <div className="">
            <button
              type="button"
              className="size-2 collapse-menu-icon"
              onClick={(e) => dispatch(collapseMenuDisplay(true))}
              aria-controls="main-menu"
              aria-expanded={menu.display}
            >
              {" "}
              <i className="bi bi-list"></i>
            </button>
          </div>
          <Nav className="  justify-content-end sub-header-content">
            <Nav.Link
              key={cartMenu.id}
              id={cartMenu.id}
              className="custom-icon-link main-menu-item"
              onClick={(e) => handleMenuDisplay(e, cartMenu)}
            >
              <i
                className="bi bi-cart2 p-overlay-badge"
                style={{ fontSize: "1.5rem", marginRight: "10px" }}
              >
                <Badge value={cartCounter}></Badge>
              </i>
            </Nav.Link>
            <Nav.Link
              key={notificationMenu.id}
              className="custom-icon-link main-menu-item"
              id={notificationMenu.id}
              onClick={(e) => handleMenuDisplay(e, notificationMenu)}
            >
              <i
                className="bi bi-bell p-overlay-badge"
                style={{ fontSize: "1.5rem" }}
              >
                <Badge value={unread_nb ? unread_nb : 0}></Badge>
              </i>
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
}
